import React  from 'react';
import ContactForm from './ContactForm';

import PageHeader from '../components/PageHeader';

import contactBg from '../../../images/contact-bg.jpg';

/* Contact us page */
const Contact = () => (
  <div>
    <PageHeader 
      heading="Contact us"
      subheading="Have questions? I have answers (maybe)."
      backgroundImage={{backgroundImage: `url(${contactBg})`}} />
    
    <div className="container">
      <p>Fill out the form below to send me a message and I will try to get back to you within 24 hours!</p>
      <ContactForm />
    </div>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/pages/Contact/Contact.js